import { FC } from 'react';
import ReactPinInput from 'react-pin-input';

export type PinInputProps = {
  onComplete: (value: string, index: number) => void;
  defaultValue?: string;
};

export const PinInput: FC<PinInputProps> = ({
  defaultValue,
  onComplete
}) => {
  const style = {
    alignItems: 'center',
    display: 'flex',
    gap: 'calc(var(--padding) * 0.5)'
  };

  const inputStyle = {
    borderColor: 'var(--color-border)',
    borderRadius: 'var(--border-radius-s)',
    borderStyle: 'solid',
    borderWidth: '1px',
    fontFamily: 'inherit',
    fontSize: 'calc(var(--font-size) * 1.6)',
    margin: '0'
  };

  return (
    <ReactPinInput
      focus
      initialValue={defaultValue}
      inputStyle={inputStyle}
      length={6}
      onComplete={onComplete}
      secret={false}
      style={style}
      type='numeric'
    />
  );
};
